import React from 'react'
import { IconoChat } from '@/components/IconoChat'
import { NeutralChatIcon } from '@/components/NeutralChatIcon'
import { ChatDotsIcon } from '@/components/ChatDotsIcon'
import { RoundedChatIcon } from '@/components/RoundedChatIcon'
import { SparkIcon } from '@/components/SparkIcon'

interface WidgetIconProps {
  iconStyle?: string
  className?: string
  style?: React.CSSProperties
}

// Maps an iconStyle config value to its icon component.
// 'brand' (the r3Converse logo) is the default.
export const WidgetIcon: React.FC<WidgetIconProps> = ({ iconStyle, className, style }) => {
  switch (iconStyle) {
    case 'neutral':
      return <NeutralChatIcon className={className} style={style} />
    case 'dots':
      return <ChatDotsIcon className={className} style={style} />
    case 'rounded':
      return <RoundedChatIcon className={className} style={style} />
    case 'spark':
      return <SparkIcon className={className} style={style} />
    default:
      return <IconoChat className={className} style={style} />
  }
}
